import { useLingui } from '@lingui/react/macro';

import type { CoreFourMetricItem } from '../../../../react-query/useCoreFourTPP';

/** TPP heatmap: 76–100% green, 51–75% amber, 0–50% red. */
const CORE_FOUR_GREEN_THRESHOLD = 76;
const CORE_FOUR_AMBER_THRESHOLD = 51;

function getCoreFourBarColorClass(percent: number): string {
  if (percent >= CORE_FOUR_GREEN_THRESHOLD) return 'vai-bg-green-600';
  if (percent >= CORE_FOUR_AMBER_THRESHOLD) return 'vai-bg-amber-300';
  return 'vai-bg-red-300';
}

const bodyTextClass = 'vai-text-base vai-leading-6 vai-text-zinc-900';

const labelBaseClass = 'vai-text-[12px] vai-leading-4 vai-text-muted-foreground';
const labelTextClass = `${labelBaseClass} vai-font-normal`;

export interface MetricCardProps {
  title: string;
  criteria: React.ReactNode;
  metrics: CoreFourMetricItem;
  plannedPrefix: string;
}

export function MetricCard({ title, criteria, metrics, plannedPrefix }: MetricCardProps) {
  const { t } = useLingui();
  const barColorClass = getCoreFourBarColorClass(metrics.percent);
  return (
    <div className="vai-flex vai-min-h-0 vai-min-w-0 vai-flex-1 vai-flex-col vai-gap-4 vai-rounded-lg vai-border vai-border-zinc-200 vai-bg-white vai-p-4">
      <div className="vai-flex vai-min-h-0 vai-flex-1 vai-flex-col vai-gap-2">
        <h4 className="vai-text-base vai-font-medium vai-leading-6 vai-text-slate-900">
          {title}
        </h4>
        <p className={bodyTextClass}>{criteria}</p>
      </div>
      <div className="vai-flex vai-shrink-0 vai-flex-col vai-gap-3">
        <span className="vai-text-[30px] vai-font-semibold vai-leading-none vai-text-slate-900">
          {metrics.percent}%
        </span>
        <div className="vai-flex vai-h-4 vai-w-full vai-rounded-2xl vai-bg-zinc-200 vai-overflow-hidden">
          <div
            className={`vai-h-full vai-rounded-l-2xl vai-border-r-[3px] vai-border-white ${barColorClass}`}
            style={{ width: `${metrics.percent}%` }}
          />
        </div>
        <p className={labelTextClass}>
          {t`${plannedPrefix} ${metrics.planned} of ${metrics.opportunities} opportunities`}
        </p>
      </div>
    </div>
  );
}
